export enum ComboPreventionResult {
    AllCombo,
    SameMarket,
    NoComboAllowed,
    SameSport,
    SameLeague,
    SameEvent,
    SameEventGroup,
    DifferentLeague,
    SameGroup, // TV2

    OnlyVirtual,
    OnlyRaceForecast, // Forecast race bet can be combinable only with forecast.
    RaceTricast, // Tricast bet is not combinable.
    SameFixture,
    SameRaceParticipant,
    SystemCombinationForecast,

    GolfV2WithGolfV1,

    XCastWithSport,
    BetBuilder, // BetBuilder bet is not combinable.
}
